<template>
    <div class="red-packet-calendar">
        <div class="calendar-list g-flex" ref="calendarListRef">
            <div class="calendar-item" v-for="item in store.mainData.daily_list" :key="item.day" @click="onClick" :class="`calendar-item-${item.status}`">
                <div class="calendar-item-top" v-if="item.status === 1">
                    <p class="calendar-item-top-text">现金红包</p>
                    <p class="calendar-item-top-num" :class="getAmountClass(item.amount)">{{ item.amount }}</p>
                </div>
                <div class="divide-resources-redpacket" v-else>
                    <p class="calendar-item-top-text calendar-item-top-text2" v-if="item.status === 0">{{ store.mainData.today_help_count > 0 || item.day_label === '待开启' ? '待开启' : '待参与' }}</p>
                </div>
                <p class="calendar-item-title">{{ item.day_label }}</p>
            </div>
            <div class="calendar-item-last"></div>
        </div>
        <div class="calendar-shadow calendar-shadow-left"></div>
        <div class="calendar-shadow calendar-shadow-right"></div>
    </div>
</template>
<script lang="ts" setup>
import { ref, watch, nextTick, onMounted, getCurrentInstance } from 'vue';
import { useStore } from '@divide/store';
const store = useStore();
// 1=已领取 0表示今日待开启 2表示未参与(之前天) 3表示将来开启

const calendarListRef = ref<HTMLElement | null>(null);
const instance = getCurrentInstance()!;
const onClick = () => {
    instance.proxy.$toast('邀请好友助力即可瓜分现金大奖！');
};
const getAmountClass = (amount: number | string) => {
    const digitCount = String(amount ?? '').replace(/\D/g, '').length;
    if (digitCount >= 5) return 'calendar-item-top-num-sm';
    if (digitCount === 4) return 'calendar-item-top-num-md';
    return '';
};
const scrollToCenter = async() => {
    const listEl = calendarListRef.value;
    if (!listEl) {
        setTimeout(() => {
            scrollToCenter();
        }, 60);
        return;
    }
    const dailyList = store.mainData.daily_list || [];
    const targetIndex = dailyList.findIndex((item: Record<string, any>) => item.status === 0);
    if (targetIndex < 0) return;
    const targetEl = listEl.children[targetIndex] as HTMLElement | undefined;
    if (!targetEl) return;

    const maxScrollLeft = Math.max(listEl.scrollWidth - listEl.clientWidth, 0);
    const targetScrollLeft = targetEl.offsetLeft - listEl.clientWidth / 2 + targetEl.clientWidth / 2;
    const finalScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
    listEl.scrollTo({ left: finalScrollLeft, behavior: 'smooth', });
};
onMounted(() => {
    scrollToCenter();
});
</script>
<style lang="scss" scoped>
.red-packet-calendar {
    margin-top: 32px;
    width: 100%;
    background: #ffffff;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
}

.calendar-list {
    overflow-x: auto;
    padding: 24px 0 24px 24px;
    &::-webkit-scrollbar {
        display: none;
    }
}
.calendar-item {
    flex-shrink: 0;
    margin-right: 20px;
    &-2 {
        opacity: 0.6;
    }
    &-last {
        width: 1px;
        margin-right: 0;
    }
    &-top {
        margin-top: 4px;
        width: 70px;
        height: 82px;
        background: linear-gradient(180deg, #ff3308 0%, #ff0e39 100%);
        border-radius: 10px;
        padding-top: 8px;
        &-text {
            text-align: center;
            font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            line-height: 18px;
            &2 {
                padding-top: 10px;
            }
        }
        &-num {
            margin: 8px auto 0;
            text-align: center;
            width: 58px;
            height: 42px;
            background: #fff4f4;
            border-radius: 6px;

            font-weight: bold;
            font-size: 24px;
            color: #ff2f2e;
            line-height: 42px;
            &-md {
                font-size: 20px;
            }
            &-sm {
                font-size: 16px;
            }
        }
    }
    &-title {
        text-align: center;
        margin-top: 4px;
        font-size: 18px;
        color: #854242;
        line-height: 26px;
    }
}
.calendar-shadow {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 40px;

    &-left {
        left: 0;
        background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    }

    &-right {
        right: 0;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
    }
}
</style>
